// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.celebration-config-hatch {
  min-height: 500px;
}
.celebration-config-hatch .ant-alert {
  margin-bottom: 15px;
}
.celebration-config-hatch .transfer-text {
  margin-left: 12px;
}
.celebration-config-hatch .ant-transfer {
  display: flex;
  list-style: none;
}
.celebration-config-hatch .spinner {
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
}
.celebration-config-hatch .ant-transfer-list-content {
  list-style: none;
}
.celebration-config-hatch .ant-pagination {
  list-style: none;
  display: flex;
  justify-content: center;
  padding: 4px 8px;
}
.celebration-config-hatch .ant-pagination .ant-pagination-prev {
  margin: 0px 10px 0px 10px;
}
.celebration-config-hatch .ant-pagination-simple-pager {
  margin: 0px 10px 0px 10px;
}
.celebration-config-hatch .ant-pagination-next {
  margin: 0px 10px 0px 10px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
